import {FC, useEffect, useMemo, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useFormContext} from 'react-hook-form'
import {Column} from 'react-table'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {useKTable} from '../../../../../../contexts/KTableProvider'
import {ScanActivityDto} from '../../../../model/cleaningStatus.model'
import {CLEANING_STATUS_SERVICES} from '../../../../services/cleaning-status.service'
import {ModalAddObservation} from './add-observation'

export const ModalObservations: FC = () => {
  const {
    data,
    setData,
    setPagination,
    setLoading,
    pagination,
    selectedOn,
    clearSelected,
    selected,
    onSelect,
    loading,
  } = useKTable()

  const {watch, setValue} = useFormContext()
  const [showForm, setShowForm] = useState(false)
  const [escaneoActividadId, setEscaneoActividadId] = useState<string>('')

  const showModalProgrammingService = watch('showModalProgrammingService')
  const cellData = watch('cellData')

  const handleOpenModal = (props: any) => {
    setEscaneoActividadId(props.row.original.EscaneoActividadId)
    setShowForm(true)
  }

  const handleOpenModalObservation = (props: any) => {
    setValue('observationId', props.row.original.EscaneoActividadId)
    setValue('showModalObservationDetails', true)
  }

  const handleClose = () => {
    setValue('showModalProgrammingService', false)
    setValue('closedObservations', true)
  }

  const columns: Column<any>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} title='Servicio Limpieza' />,
        accessor: 'Actividad',
        Cell: ({value}) => value || '-',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Estado' />,
        accessor: 'Estado',
        width: 100,
        Cell: ({value}) => value || '-',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Agregar observación' />,
        id: 'actions',
        width: 30,
        Cell: ({...props}) => (
          <>
            <div className='d-flex flex-shrink-0' onClick={() => handleOpenModal(props)}>
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          </>
        ),
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver observación' />,
        id: 'view',
        width: 30,
        Cell: ({...props}) => (
          <>
            <div className='d-flex flex-shrink-0' onClick={() => handleOpenModalObservation(props)}>
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen021.svg' className='svg-icon-3' />
              </a>
            </div>
          </>
        ),
      },
    ],
    [],
  )

  useEffect(() => {
    if (cellData && showModalProgrammingService) {
      getActivitiesByCampamentoList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage, showModalProgrammingService, cellData])

  const getActivitiesByCampamentoList = async () => {
    try {
      let dto: ScanActivityDto = {
        ModuloId: cellData.moduloId,
        HabitacionId: cellData.habitacionId,
        Fecha: cellData.fecha,
        EscaneoId: cellData.escaneoId,
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
      }
      setLoading(true)
      const {data: response} = await CLEANING_STATUS_SERVICES.getListEscaneoActividad(dto)
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
    } catch (error) {
      console.error('Error al buscar programaciones:', error)
      setData([])
      setPagination({
        currentPage: 1,
        perPage: 10,
        totalResults: 0,
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      className='modal fade'
      show={showModalProgrammingService}
      dialogClassName='modal-xl'
      size='xl'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Servicios de Limpieza</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          {loading ? <KTableLoading title='Cargando...' /> : null}
          <KTable
            data={data}
            columns={columns as any}
            getRowClassName={(row) => {
              if (row.original.Estado === 'COMPLETADO') return 'bg-light-success'
              if (row.original.Estado === 'OBSERVADO') return 'bg-light-warning'
              if (row.original.Estado === 'PENDIENTE') return 'bg-light'
              return ''
            }}
          />
        </div>
        <ModalAddObservation
          show={showForm}
          setShow={setShowForm}
          escaneoActividadId={escaneoActividadId}
          onSuccess={getActivitiesByCampamentoList}
        />
      </div>
    </Modal>
  )
}
